import React, { Component } from "react";
import { Link } from "react-router-dom";

//import Header from "../component/Header";
import HeaderAudioBook from "../component/HeaderAudioBook";
import BottomNavAudioBook from "../component/BottomNavAudioBook";

import BookScrollList from "../component/BookScrollList";
import BookRank from "../component/BookRank";
import BookGrid from "../component/BookGrid";

//import { browserHistory } from 'react-router'

import "../scss/style.scss";

import cookie from 'react-cookie';

import ReactGA from 'react-ga';
ReactGA.initialize('UA-125086411-4');

//var DEBUG=true;
var DEBUG=false;

class HomeAudioBook extends Component {

	constructor(props) {
		super(props);
		this.state = { headerTitle: "더책", loading: true, noback: true, suggest:[], book_category_stat:{},
                         servicetype:40 
                        };
                        if(props.match.params.servicetype !== null) {
                           this.state.servicetype= parseInt(props.match.params.servicetype);
                        }
		//this.props.history = []; //.push('/');

		//this.props.history.push("/");
		//this.props.history.replace('', null);

		//browserHistory.replace('/');

		//alert(JSON.stringify(this.props));     

        let struserid = cookie.load("userid");
        let struserdbid = cookie.load("userdbid");
        let device_struserid = cookie.load("device_userid");
        let device_struserdbid = cookie.load("device_userdbid");
        let general_struserid = cookie.load("general_userid");
        let general_struserdbid = cookie.load("general_userdbid");
        if(DEBUG) console.log("cookie userid: " + struserid);
        if(DEBUG) console.log("cookie userdbid: " + struserdbid);
        if(DEBUG) console.log("cookie device_userid: " + device_struserid);
        if(DEBUG) console.log("cookie device_userdbid: " + device_struserdbid);
        if(DEBUG) console.log("cookie general_userid: " + general_struserid);
        if(DEBUG) console.log("cookie general_userdbid: " + general_struserdbid);
        if(general_struserid !== undefined && general_struserid.length>36) {
            this.removeCookie_only_general();
            general_struserid = cookie.load("general_userid");
            general_struserdbid = cookie.load("general_userdbid");
        }

        if(struserid !== undefined && general_struserid !== undefined) { 
            if(struserid === general_struserid) { 
                if(struserid.length >= 36) { //logout general user except for device_user
                    this.removeCookie();
                    struserid= undefined;
                    struserdbid= undefined;
                } else {
                    //good do nothing!
                };
            } else {
                this.removeCookie();
                this.copy_general_cookie_to_cookie();
                struserid= general_struserid;;
                struserdbid= general_struserdbid;;
            };
        } else 
        if(struserid !== undefined && general_struserid === undefined) { 
            if(struserid.length >= 36) { //logout device user except for general_user
                this.copy_cookie_to_device_cookie();
                this.removeCookie();
                struserid= undefined;
                struserdbid= undefined;
            } else {
                //good do nothing!
                this.copy_cookie_to_general_cookie();
            };
        } else 
        if(struserid === undefined && general_struserid !== undefined) { 
            if(general_struserid.length >= 36) { //logout device user except for general_user
                // no logon cookie
            } else {
                this.copy_general_cookie_to_cookie();
                struserid= general_struserid;;
                struserdbid= general_struserdbid;;
            };
        } else 
        if(struserid === undefined && general_struserid === undefined) { 
                // no logon cookie
        };

        let struserid2 = cookie.load("userid");
        let struserdbid2 = cookie.load("userdbid");
        let device_struserid2 = cookie.load("device_userid");
        let device_struserdbid2 = cookie.load("device_userdbid");
        let general_struserid2 = cookie.load("general_userid");
        let general_struserdbid2 = cookie.load("general_userdbid");
        if(DEBUG) console.log("!cookie userid: " + struserid2);
        if(DEBUG) console.log("!cookie userdbid: " + struserdbid2);
        if(DEBUG) console.log("!cookie device_userid: " + device_struserid2);
        if(DEBUG) console.log("!cookie device_userdbid: " + device_struserdbid2);
        if(DEBUG) console.log("!cookie general_userid: " + general_struserid2);
        if(DEBUG) console.log("!cookie general_userdbid: " + general_struserdbid2);

        if ( struserid === undefined ||
             struserid === null ||
             struserid.length < 1 || 
             struserid.length>35 && struserid.indexOf("@") === -1) {

             let signin_url="/signin_audiobook?from_url="+props.location.pathname;
             if(DEBUG) console.log("new signin url "+signin_url);
             props.history.replace(signin_url);
            return;
        }

        let orgid = cookie.load("orgid");
        if (typeof orgid === 'undefined')
            orgid = -1;

        fetch('/api/AB/GetOrgInfo?orgid=' + orgid)
            .then(response => response.json())
            .then(data => {
        if(DEBUG) console.log("ORGINFO");
        if(DEBUG) console.log(data);

        fetch('/api/AB/GetBookCateCounts?orgid=' + orgid+"&site=1")
            .then(response => response.json())
            .then(data2 => {
                if(DEBUG) console.log("ORGCATEBOOK");
                if(DEBUG) console.log(data2);
                this.setState({ ...this.state, loading: false, suggest: data.lstresult,  book_category_stat: data2.dicresult });
            });

                //this.setState({ ...this.state, loading: false, suggest: data.lstresult });
            });
    }



setCookie_THECHAEK(userid, strdbid, orgid, logoncount, llendbookcount, orgname, sbc) {
    let d = new Date();
    d.setTime(d.getTime() + (12 * 60 * 60 * 1000));
    cookie.save("userid", userid, { path: "/", expires: d });
    cookie.save("userdbid", strdbid, { path: "/", expires: d });
    cookie.save("orgid", orgid, { path: "/", expires: d });
    cookie.save("lc", logoncount, { path: "/", expires: d });
    cookie.save("lendc", llendbookcount, { path: "/", expires: d });
    cookie.save("orgname", orgname, { path: "/", expires: d });
    cookie.save("sbc", sbc, { path: "/", expires: d });
    cookie.save("device_userid", userid, { path: "/", expires: d });
    cookie.save("device_userdbid", strdbid, { path: "/", expires: d });
    cookie.save("device_orgid", orgid, { path: "/", expires: d });
    cookie.save("device_lc", logoncount, { path: "/", expires: d });
    cookie.save("device_lendc", llendbookcount, { path: "/", expires: d });
    cookie.save("device_orgname", orgname, { path: "/", expires: d });
    cookie.save("device_sbc", sbc, { path: "/", expires: d });
    };

    
setCookie_AUDIOBOOK(userid, strdbid, orgid, logoncount, llendbookcount, orgname, sbc) {
    let d = new Date();
    d.setTime(d.getTime() + (12 * 60 * 60 * 1000));
    cookie.save("userid", userid, { path: "/", expires: d });
    cookie.save("userdbid", strdbid, { path: "/", expires: d });
    cookie.save("orgid", orgid, { path: "/", expires: d });
    cookie.save("lc", logoncount, { path: "/", expires: d });
    cookie.save("lendc", llendbookcount, { path: "/", expires: d });
    cookie.save("orgname", orgname, { path: "/", expires: d });
    cookie.save("sbc", sbc, { path: "/", expires: d });
    cookie.save("general_userid", userid, { path: "/", expires: d });
    cookie.save("general_userdbid", strdbid, { path: "/", expires: d });
    cookie.save("general_orgid", orgid, { path: "/", expires: d });
    cookie.save("general_lc", logoncount, { path: "/", expires: d });
    cookie.save("general_lendc", llendbookcount, { path: "/", expires: d });
    cookie.save("general_orgname", orgname, { path: "/", expires: d });
    cookie.save("general_sbc", sbc, { path: "/", expires: d });
    };

    
removeCookie() {
    cookie.remove("userid", { path: '/' });
    cookie.remove("userdbid", { path: '/' });
    cookie.remove("orgid", { path: '/' });
    cookie.remove("lc", { path: '/' });
    cookie.remove("lendc", { path: '/' });
    cookie.remove("orgname", { path: '/' });
    cookie.remove("sbc", { path: '/' });
};

removeCookie_device_complete(userid) {
    cookie.remove("userid", { path: '/' });
    cookie.remove("userdbid", { path: '/' });
    cookie.remove("orgid", { path: '/' });
    cookie.remove("lc", { path: '/' });
    cookie.remove("lendc", { path: '/' });
    cookie.remove("orgname", { path: '/' });
    cookie.remove("sbc", { path: '/' });
    cookie.remove("device_userid", { path: '/' });
    cookie.remove("device_userdbid", { path: '/' });
    cookie.remove("device_orgid", { path: '/' });
    cookie.remove("device_lc", { path: '/' });
    cookie.remove("device_lendc", { path: '/' });
    cookie.remove("device_orgname", { path: '/' });
    cookie.remove("device_sbc", { path: '/' });
};

removeCookie_general_complete(userid) {
    cookie.remove("userid", { path: '/' });
    cookie.remove("userdbid", { path: '/' });
    cookie.remove("orgid", { path: '/' });
    cookie.remove("lc", { path: '/' });
    cookie.remove("lendc", { path: '/' });
    cookie.remove("orgname", { path: '/' });
    cookie.remove("sbc", { path: '/' });
    cookie.remove("general_userid", { path: '/' });
    cookie.remove("general_userdbid", { path: '/' });
    cookie.remove("general_orgid", { path: '/' });
    cookie.remove("general_lc", { path: '/' });
    cookie.remove("general_lendc", { path: '/' });
    cookie.remove("general_orgname", { path: '/' });
    cookie.remove("general_sbc", { path: '/' });
};

copy_cookie_to_device_cookie() {
  this.setCookie_THECHAEK(
    cookie.load("userid"),
    cookie.load("userdbid"),
    cookie.load("orgid"),
    cookie.load("lc"),
    cookie.load("lendc"),
    cookie.load("orgname"),
    cookie.load("sbc")
  );
};

copy_cookie_to_general_cookie() {
  this.setCookie_AUDIOBOOK(
    cookie.load("userid"),
    cookie.load("userdbid"),
    cookie.load("orgid"),
    cookie.load("lc"),
    cookie.load("lendc"),
    cookie.load("orgname"),
    cookie.load("sbc")
  );
};

copy_device_cookie_to_cookie() {
  this.setCookie_THECHAEK(
    cookie.load("device_userid"),
    cookie.load("device_userdbid"),
    cookie.load("device_orgid"),
    cookie.load("device_lc"),
    cookie.load("device_lendc"),
    cookie.load("device_orgname"),
    cookie.load("device_sbc")
  );
};

copy_general_cookie_to_cookie() {
  this.setCookie_AUDIOBOOK(
    cookie.load("general_userid"),
    cookie.load("general_userdbid"),
    cookie.load("general_orgid"),
    cookie.load("general_lc"),
    cookie.load("general_lendc"),
    cookie.load("general_orgname"),
    cookie.load("general_sbc")
  );
};




    dorender() {
        let orgid = cookie.load("orgid");
        if (typeof orgid === 'undefined')
            orgid = 0;
    
        
        //var char_sq=0x25a0; 
        //var char_sq={String.fromCharCode(char_sq)};
        var char_sq=String.fromCharCode(0x2022);
        var color_sq="#26c6da";
        var st_category=[]; 
        var cstat= this.state.book_category_stat; 
        if(cstat["book_counts_all"] !== undefined) {
            var clist= cstat["category_list"];
            var blist= cstat["book_counts_by_categories"];
            var st_cate=[];
            var int_all_count=  cstat["book_counts_all"];

            var link0= {
                pathname: '/BookListCategory_AudioBook',
                state:{
                    category: 0,
                    cate: 0, 
                    subtitle:"전체",
					sw: '',
					ow: 0,
					ob: 2,
					al: '',
					    st: 40,
					    lg: 0
                } 
            };
                st_category.push(
                            <div className="section-category-item-lsb">
                                <Link to={link0} > <h4> <font color={color_sq} size={4}>{char_sq}</font> {"전체"} ( {int_all_count} ) </h4> </Link>
                            </div>
            );

            for (let i = 0; i < clist.length; i++) {
                let intBCount = 0;
                let intCateNum = -1;
                var strCateName = clist[i].categoryName;
                
                for (let j = 0; j < blist.length; j++) {
                    let strCateNum = blist[j]["refcateid"];
                    intCateNum = parseInt(strCateNum);

                    if (clist[i].id === intCateNum) {
                        intBCount = blist[j]["bcount"];
                        break;
                    };
                    
                }

                if (intBCount > 0) {
                    let link1 = {
                        pathname: '/BookListCategory_AudioBook',
                        state: {
                            category: intCateNum,
                            cate: intCateNum,
                            subtitle: strCateName,
                            sw: '',
                            ow: 0,
                            ob: 0,
                            al: '',
                            st: 40,
                            lg: 0
                        }
                    };

                    st_category.push(
                        <div className="section-category-item-lsb">
                            <Link to={link1} > <h4><font color={color_sq} size={4}>{char_sq}</font> {strCateName} ( {intBCount} ) </h4></Link>
                        </div>
                    );
                    if (false) st_category.push(
                        <div className="section-category-item-lsb">
                            <Link to={link1} > <span style={{ color: color_sq, fontSize: "18px", fontWeight: "bold" }}>{String.fromCharCode(char_sq)} {strCateName} ( {intBCount} ) </span></Link>
                        </div>
                    );
                }
            }
            
        };
        
        
        let st_suggest = [];
        let suggest = this.state.suggest;
        let suggestnumber;

        if(DEBUG) console.log(this.state);

        if (typeof suggest !== 'undefined') {
            for (let i = 0; i < suggest.length; i++) {
                suggestnumber = suggest[i].refsuggesttype;


	        let link_data=	{
			    pathname:"/BookListSuggest_AudioBook",
			    state:{
				    sgt:suggestnumber,
					sw: '',
					ow: 0,
					ob: 2,
					al: '',
                    st: 40,
                    lg: 0,
					subtitle: suggest[i].typedesc
			    }
		};
                st_suggest.push(<div className="section-suggest">
                    <div className="section1-header-suggest">
                        <h2 className="section-title">
                            <Link to={link_data} >{suggest[i].typedesc}</Link>
                        </h2>
                        <div className="section-title-more-lsb2">
                            <Link to={link_data} className="section-title-more-lsb2-link"> 더보기 > </Link>
                        </div>
                    </div>
                    <div className="section-body-suggest">
                        <BookScrollList fetchurl={`/api/AB/BookListBySuggest?suggesttype=${suggestnumber}&orderby=2&orderway=0&pgsize=100&servicetype=${this.state.servicetype}`} />
                    </div>
                </div>)

            }
        }

        return (
            <React.Fragment>
                <HeaderAudioBook headerTitle={this.state.headerTitle}  subTitle={"오디오 라이브러리"} />
                
                <div className="section">
                    <div className="section1-header">
                        <h2 className="section-title">
                        카테고리 
                        </h2>
                    </div>
                    <div className="section-category-body-lsb">
        {st_category}
                    </div>
                </div>

                    <br/> 
                {st_suggest}

                <div className="section">
                    <div className="section-header">
                        <h2 className="section-title">
                            <Link to="/cateview_audiobook">전체 오디오북</Link>
                        </h2>
                        <div className="section-title-more">
                            <Link to="/cateview_audiobook">전체 목록보기</Link>
                        </div>
                    </div>
                    <div className="section-body">
                        <BookScrollList fetchurl={"/api/AB/BookListR2?pgidx=0&pgsize=50&orderby=100&orderway=0&servicetype="+this.state.servicetype} />
                    </div>
                </div>
                <BottomNavAudioBook />
            </React.Fragment>
        );
    }

    logPageView() {
        ReactGA.set({ page: window.location.pathname });
        ReactGA.pageview(window.location + "&orgid=" + cookie.load("orgid"));
    }

    render() {
        

        let contents = this.state.loading === true
            ? <p className="section-description">Loading...</p>
            : this.dorender(); this.logPageView();

        return (
            <React.Fragment>
                    {contents}
            </React.Fragment>
        );
	}
}

export default HomeAudioBook;
